import React from "react";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, LineElement, PointElement, ArcElement, Title, Tooltip, Legend, ChartData, ChartOptions, } from "chart.js";
import { Bar, Line, Pie, Doughnut } from "react-chartjs-2";
import { Code } from "constants/codes";

ChartJS.register( CategoryScale, LinearScale, BarElement, LineElement, PointElement, ArcElement, Title, Tooltip, Legend );
enum ChartType { BAR = 10,  LINE = 11, PIE = 12, DOUGHNUT = 13, }

type Props = {
  type: ChartType;
  data: ChartData<any>;
  option: ChartOptions<any>;
};

const applyChartStyle = (
  type: ChartType,
  baseData: ChartData<"bar" | "line" | "pie" | "doughnut">
): ChartData<any> => {
  const colorList = [ Code.Chart.Color.color1, Code.Chart.Color.color2, Code.Chart.Color.color3, Code.Chart.Color.color4, Code.Chart.Color.color5, Code.Chart.Color.color6, Code.Chart.Color.color7, Code.Chart.Color.color8, Code.Chart.Color.color9, Code.Chart.Color.color10, Code.Chart.Color.color11, Code.Chart.Color.color12, Code.Chart.Color.color13, Code.Chart.Color.color14, Code.Chart.Color.color15, Code.Chart.Color.color16, Code.Chart.Color.color17, Code.Chart.Color.color18, Code.Chart.Color.color19, Code.Chart.Color.color20 ];

  const datasets = baseData.datasets.map((ds, index) => {
    const color = colorList[index % colorList.length];

    const styledDataset: any = {
      ...ds,
      backgroundColor: color,
    };

    if (type === ChartType.LINE) {
      styledDataset.borderColor = color;
      styledDataset.tension = 0.2;
    }

    return styledDataset;
  });

  return {
    ...baseData,
    datasets,
  };
};

const ChartDesigner: React.FC<Props> = ({ type, data, option }) => {
  const chartMap: Record<ChartType, React.ElementType> = {
    [ChartType.BAR]: Bar,
    [ChartType.LINE]: Line,
    [ChartType.PIE]: Pie,
    [ChartType.DOUGHNUT]: Doughnut,
  };

  const chartData = applyChartStyle(type, data);
  

  const ChartComponent = chartMap[type];
  return <ChartComponent data={chartData} options={option} />;
};

export default ChartDesigner;